import { render, staticRenderFns } from "./EduCourseStudent.vue?vue&type=template&id=942b9140&scoped=true"
import script from "./EduCourseStudent.vue?vue&type=script&lang=js"
export * from "./EduCourseStudent.vue?vue&type=script&lang=js"
import style0 from "./EduCourseStudent.vue?vue&type=style&index=0&id=942b9140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942b9140",
  null
  
)

export default component.exports